import Vue from 'vue'
import App from './App.vue'
import store from "./store";

Vue.config.productionTip = false
Vue.config.devtools = true;
Vue.prototype.Miele = window.Miele;

new Vue({
  store,
  render: h => h(App),
}).$mount('#product-filter-app')
